import { render, staticRenderFns } from "./RewardDrawer.vue?vue&type=template&id=308c5494&scoped=true"
import script from "./RewardDrawer.vue?vue&type=script&lang=js"
export * from "./RewardDrawer.vue?vue&type=script&lang=js"
import style0 from "./RewardDrawer.vue?vue&type=style&index=0&id=308c5494&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "308c5494",
  null
  
)

export default component.exports